/*
 * Active filter chips in the collection nav (snippets/collection-active-filters.liquid).
 * collection-filters-form.js replaces the sidebar's innerHTML after each filter change; the chips follow the sidebar's copy.
 */

(function () {
  class CollectionActiveFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.closest("[data-section-id]");
      this.sidebar = this.section?.querySelector("[data-collection-sidebar]");
      if (!this.sidebar) return;

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.sidebar, { childList: true });
      this.addEventListener("click", this);
      this.addEventListener("focusin", this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener("click", this);
      this.removeEventListener("focusin", this);
    }

    sync() {
      const chips = this.sidebar.querySelector(".collection__active__filters");
      this.innerHTML = chips ? chips.innerHTML : "";
      this.querySelectorAll("[data-filter-update-url]").forEach((link) =>
        link.removeAttribute("data-filter-update-url"),
      );
    }

    handleEvent(event) {
      if (event.type === "focusin") {
        this.revealFocusedChip(event.target);
        return;
      }

      // Modified and non-primary clicks keep the browser's default (open in a new tab or window).
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target.closest("a[href]");
      const form = this.section.querySelector("collection-filters-form");
      if (!link || typeof form?.submitForm !== "function") return;

      event.preventDefault();
      form.submitForm(event, link.getAttribute("href"));
    }

    // Chrome's focus scroll can leave a half-hidden chip where it is. For keyboard focus only, scroll the row
    // sideways so the whole chip and its ring show. Mouse focus is left alone: moving the chip between
    // mousedown and mouseup would lose the click. Only this row scrolls, never the page.
    revealFocusedChip(chip) {
      const keyboard =
        document.body.classList.contains("is-focused") || chip.matches(":focus-visible");
      if (!keyboard) return;

      const style = getComputedStyle(this);
      const row = this.getBoundingClientRect();
      const rowStart =
        row.left + this.clientLeft + (parseFloat(style.scrollPaddingInlineStart) || 0);
      const rowEnd =
        row.left +
        this.clientLeft +
        this.clientWidth -
        (parseFloat(style.scrollPaddingInlineEnd) || 0);
      const box = chip.getBoundingClientRect();

      if (box.left < rowStart) {
        this.scrollLeft -= rowStart - box.left;
      } else if (box.right > rowEnd) {
        this.scrollLeft += box.right - rowEnd;
      }
    }
  }

  if (!customElements.get("collection-active-filters")) {
    customElements.define("collection-active-filters", CollectionActiveFilters);
  }
})();
